export default __webpack_public_path__ + "static/media/right.ba7a325b.svg";